import React, { useState, useEffect } from "react";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import BiztranControls from "../../biztran_controls/BiztranControls";
import { Link } from 'react-router-dom';
import { DatePickerInput } from 'rc-datepicker';
import 'moment/locale/it.js';
import 'rc-datepicker/lib/style.css';
import Moment from "moment";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import UseFetchData from "../../../hooks/UseFetchData";
import CreateOpportunity from "../../crm/opportinities/CreateOpportunity";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import { debounce, Grid, Tooltip } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import moment from "moment";


const todate = new Date();
// var fromdate = todate.getFullYear() + '/07/01';
const fromdate = new Date(todate.getFullYear(), todate.getMonth(), 1);


const useStyles = makeStyles((theme) => ({
  pagecontrolmaxwidth: {
    maxWidth: '180px',
  }

}));

const Opportunity = () => {
  const classes = useStyles();
  // const [viewPath, setviewPath] = useState('')
  const [Product, setProduct] = useState('');
  const [ProductID, setProductID] = useState('');
  const [Productcmb, setProductcmb] = useState([]);
  const [OpportunityID, setOpportunityID] = useState('')
  const [OpportunityNo, setOpportunityNo] = useState('');
  const [Lead, setLead] = useState('');
  const [AccountName, setAccountName] = useState('');
  const [ProductOptions, setProductOptions] = useState([]);
  const [ProductName, setProductName] = useState();
  const [responseProduct, fetchProductData] = UseFetchData();
  const [City, setCity] = useState('');
  const [Count, setCount] = useState();
  const [FromDate, setFromDate] = useState(fromdate);
  const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
  const [ToDate, setToDate] = useState(todate.toISOString());
  const [defaultToDate, setdefaultToDate] = useState(todate);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isOpen, setOpen] = useState(false);
  const [response, fetchData] = UseFetchData();
  const [Description, setDescription] = useState('');
  const [ProductIDcmb, setProductIDcmb] = useState([]);
  const [ComboDataResponse, fetchComboData] = UseFetchData();
  const [OpportunityStage, setOpportunityStage] = useState("");
  const [SearchMode, setSearchMode] = useState("SEARCH");
  // const [UserID, setUserID] = useState("UserID");




  const OpportunityStageOption = [
    { id: "New", title: "New" },
    { id: "Quotation", title: "Quotation" },
  ];


  const ProductData = () => {
    var bodyFormData = new FormData();
    fetchProductData("Opportunity/ComboDataOpp", bodyFormData);
  }

  const onProductChange = (event, newValue) => {
    // debugger;
    setProductName(newValue);
    setProductID(newValue.id)
  }


  useEffect(() => {
    ProductData();
    PopulateData('SEARCH');
  }, [])

  useEffect(() => {
//    debugger;
    if (responseProduct['cmbProduct'] !== undefined && responseProduct['cmbProduct'].length > 0) {
      setProductOptions(responseProduct['cmbProduct']);
    }
    else {
      setProductOptions([]);
    }
  }, [responseProduct['cmbProduct']]);


  // const GetComboData = () => {
  //   var bodyFormData = new FormData();
  //   bodyFormData.append("ProductID", "");
  //   bodyFormData.append("ProductCat1ID", "");
  //   bodyFormData.append("ProductCat2ID", "");
  //   bodyFormData.append("ProductCat3ID", "");
  //   fetchComboData("Opportunity/ComboData", bodyFormData);
  // };

  const handleOpenModal = () => {
    setOpen(true);
    setOpportunityID('');
  }


  const PopulateData = (SearchMode) => {
    // debugger;
    var bodyFormData = new FormData();
    setSearchMode(SearchMode);
    if (SearchMode === 'SEARCH') {
      bodyFormData.append("UserID", sessionStorage.UID);
      bodyFormData.append("UserType", sessionStorage.UserType);
      bodyFormData.append("UserGroupID", sessionStorage.UserGroupID);
      bodyFormData.append("AccountName", AccountName);
      // bodyFormData.append("LeadNo", Lead);
      bodyFormData.append("City", City);
      bodyFormData.append("OpportunityStage", OpportunityStage);
      bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
      bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
      bodyFormData.append("OpportunityNo", OpportunityNo);
      bodyFormData.append("ProductID", ProductID);
      fetchData("Opportunity/OpportunityList", bodyFormData);
    }
    else if (SearchMode === 'DETAILS') {
      bodyFormData.append("UserID", sessionStorage.UID);
      bodyFormData.append("ProductID", ProductID);
      bodyFormData.append("Description", Description);
      fetchData("Opportunity/OpportunityList", bodyFormData);
    }
    else {
      bodyFormData.append("UserID", sessionStorage.UID);
      bodyFormData.append("AccountName", AccountName);
      // bodyFormData.append("LeadNo", Lead);
      bodyFormData.append("City", City);
      bodyFormData.append("OpportunityStage", OpportunityStage);
      bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
      bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
      bodyFormData.append("OpportunityNo", OpportunityNo);
      bodyFormData.append("ProductID", ProductID);
      fetchData("Opportunity/OpportunityList", bodyFormData);
    }
  }

  const onFromClear = () => {
    setFromDate('');
    setdefaultfromDate('');
  }

  const onToClear = () => {
    setToDate('');
    setdefaultToDate('');
  }

  useEffect(
    () => {
      let copygridclm = [];
      const gridCols = [
        {
          field: "id",
          headerName: ".",
          renderCell: (params) => (<strong> <Link to={{ pathname: "/Opportunity/OpportunityView", state: { OpportunityID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
          //renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong>),
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 70,
        },
        {
          field: "OpportunityNo",
          headerName: "Opportunity No",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
        },
        {
          field: "OpportunityDate",
          headerName: "Opportunity Date",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
          valueFormatter: params =>
            moment(params?.value).format("DD/MM/YYYY"),
        },
        {
          field: "LeadNo",
          headerName: "Lead No",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 180,
        },
        {
          field: "AccountName",
          headerName: "Account",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 180,
          renderCell: (params) => (
            <Tooltip title={params.row.AccountName} >
              <span className="table-cell-trucate">{params.row.AccountName}</span>
            </Tooltip>
          ),
        },
        {
          field: "ContactName",
          headerName: "Contact",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 180,
        },
        {
          field: "LeadSource",
          headerName: "LeadSource",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 180,
        },
        // {
        //   field: "OpportunityType",
        //   headerName: "Opportunity Type",
        //   headerClassName: "super-app-theme--header",
        //   headerAlign: "center",
        //   width: 200,
        // },
        {
          field: "OpportunityStage",
          headerName: "Opportunity Stage",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 230,
        },
      ];
      if (SearchMode === 'DETAILS') {
        const gridclm0 = [{
          field: "ProductName",
          headerName: "Product Name",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
          renderCell: (params) => (
            <Tooltip title={params.row.ProductName} >
              <span className="table-cell-trucate">{params.row.ProductName}</span>
            </Tooltip>
          ),
        },
        {
          field: "ModelCode",
          headerName: "Model Code",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
        },
        {
          field: "Description",
          headerName: "Description",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
          renderCell: (params) => (
            <Tooltip title={params.row.Description} >
              <span className="table-cell-trucate">{params.row.Description}</span>
            </Tooltip>
          )
        },
        {
          field: "Quantity",
          headerName: "Quantity",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
        },
        {
          field: "Rate",
          headerName: "Rate",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
        },
        {
          field: "Amount",
          headerName: "Amount",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
        }];
        copygridclm = gridCols.concat(gridclm0);

      }

      const gridclm7 = [{
        field: "GeneratedBy",
        headerName: "GeneratedBy",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "HandledBy",
        headerName: "HandledBy",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "PredictedClosingDate",
        headerName: "Predicted Closing Date",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 250,
        valueFormatter: params =>
          moment(params?.value).format("DD/MM/YYYY"),
      },
      {
        field: "BillAddress1",
        headerName: "Bill Address1",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => (
          <Tooltip title={params.row.BillAddress1} >
            <span className="table-cell-trucate">{params.row.BillAddress1}</span>
          </Tooltip>
        )
      },
      // {
      //   field: "BillAddress2",
      //   headerName: "Bill Address2",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      //   renderCell: (params) => (
      //     <Tooltip title={params.row.BillAddress2} >
      //       <span className="table-cell-trucate">{params.row.BillAddress2}</span>
      //     </Tooltip>
      //   )
      // },
      {
        field: "BillCity",
        headerName: "Bill City",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "BillCountry",
        headerName: "Bill Country",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "BillState",
        headerName: "Bill State",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      ];

      if (SearchMode === 'DETAILS') {
        copygridclm = copygridclm.concat(gridclm7);
      }
      else {
        copygridclm = gridCols.concat(gridclm7);
      }
      setColumns(copygridclm);
      setRows(response);
      setCount(response.length);
    }, [response, SearchMode]
  );



  function CustomToolbar() {
    return (
      <GridToolbarContainer style={{ marginLeft: '93%' }}>
        <GridToolbarExport csvOptions={{
          fields: ['ProductID', 'OpportunityNo', 'OpportunityDate', 'LeadNo', 'AccountName', 'ContactName', 'LeadSource',
            'OpportunityType', 'OpportunityStage', 'ProductName', 'ModelCode', 'Description', 'Quantity', 'Rate', 'Amount', 'GeneratedBy',
            'HandledBy', 'PredictedClosingDate', 'TotalAmount', 'GstAmount', 'BillAddress1',
            'BillAddress2', 'BillCity', 'BillCountry', 'BillState', 'BillPINCode', 'ShipAddress1', 'ShipAddress2', 'ShipCity',
            'ShipCountry', 'ShipState', 'ShipPINCode']
        }} />
      </GridToolbarContainer>
    );
  }


  /* if (viewPath) return (
    <Redirect to={{ pathname: viewPath, state: { OpportunityID: OpportunityID } }} />
  ); */

  return (
    <div >

      <Grid container direction="row" style={{ marginTop: 10 }} spacing={0.5} >
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ paddingTop: 0, marginLeft: 25 }}>
          <BiztranControls.Autocomplete
            label="Product"
            style={{ width: "220px" }}
            options={ProductOptions}
            onChange={debounce(onProductChange, 300)}
            value={Product}>
          </BiztranControls.Autocomplete>
        </Grid>
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: -7 }} >
          <BiztranControls.Input
            label="Opportunity No"
            id="accName"
            style={{ width: "180px" }}
            onChange={(e) => setOpportunityNo(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: -7 }}>
          <BiztranControls.Input
            label="Account Name"
            id="AccountName"
            style={{ width: "180px" }}
            onChange={(e) => setAccountName(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: -7 }}>
          <BiztranControls.Select
            label="Status"
            id="OpportunityStage"
            options={OpportunityStageOption}
            style={{ width: "180px" }}
            onChange={(e) => setOpportunityStage(e.target.value)}
            SelectProps={{
              native: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: -7 }}>
          <BiztranControls.Input
            label="Model No/Description"
            id="Description"
            style={{ width: "180px" }}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Grid>
      </Grid>
      <Grid container direction="row" style={{ marginTop: 10, paddingTop: 0, marginLeft: 25 }} spacing={0.5}>
        <Grid item xs={12} sm={3} md={2} lg={2} xl={2}>
          <BiztranControls.Input
            label="City"
            id="city"
            style={{ width: "180px" }}
            onChange={(e) => setCity(e.target.value)}
          />
        </Grid>
        {/* <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 8 }}> */}
        <Grid item xs={12} sm={4} md={2} lg={2} xl={2} style={{ marginTop: -12, }}>
          <div style={{ width: "180px", marginLeft: 6 }}>
            <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
            <DatePickerInput
              onChange={(jsDate, dateString) => setFromDate(dateString)}
              locale="en"
              displayFormat="DD/MMM/YYYY"
              className='my-react-component'
              onClear={() => { onFromClear(); }}
              showOnInputClick
              maxDate={new Date()}
              returnFormat="YYYY/MM/DD"
              defaultValue={defaultfromDate}
            />
          </div>
        </Grid>
        {/* <Grid item xs={12} sm={4} md={2} lg={2} xl={2} style={{ marginTop: 8, paddingTop: 0, paddingBottom: 0 }}> */}
        <Grid item xs={12} sm={3} md={2} lg={2} xl={2} style={{ marginTop: -12, marginLeft: 10 }}>
          <div style={{ width: "180px", marginLeft: 6 }}>
            <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
            <DatePickerInput
              onChange={(jsDate, dateString) => setToDate(dateString)}
              locale="en"
              displayFormat="DD/MMM/YYYY"
              className='my-react-component'
              onClear={() => { onToClear(); }}
              showOnInputClick
              maxDate={new Date()}
              returnFormat="YYYY/MM/DD"
              defaultValue={defaultToDate}
            />
          </div>
        </Grid>
        <Grid container xs={12} sm={12} md={3} lg={4} xl={2} direction="row" >
          <Grid item >
            <BiztranControls.Button
              responsive="true"
              text="SEARCH"
              startIcon={<SearchIcon />}
              onClick={() => {
                PopulateData('SEARCH');
              }}
            />
          </Grid>

          <Grid item>
            <div >
              <label style={{ fontWeight: 'bold', width: 7, marginTop: 35 }}>{Count}</label>
            </div>
          </Grid>

          <Grid item >
            <BiztranControls.Button
              responsive="true"
              text="DETAILS"
              startIcon={<SearchIcon />}
              onClick={() => {
                PopulateData('DETAILS');
              }}
            />
          </Grid>

          <Grid item  >
            <BiztranControls.Button
              responsive="true"
              text="ADD NEW"
              startIcon={<AddCircleOutlineIcon />}
              onClick={() => {
                handleOpenModal();
              }}
            />
          </Grid>

        </Grid>
      </Grid>
      <BiztranControls.DataGrid
        rowHeight={23}
        rows={rows}
        columns={columns}
        checkboxSelection={false}
        // autoHeight={true}
        Height="400px"
        //Height="700px"
        Width="100%"
        components={{ Toolbar: CustomToolbar, }}
      />
      <ModalFrame
        title="Opportunity Details"
        maxWidth="md"
        isOpen={isOpen}
        headerAlign="center"
        setOpen={setOpen}
      >
        <CreateOpportunity
          OpportunityID={OpportunityID}
          PopulateData={PopulateData}
          setOpen={setOpen}
          disabled={true}
        />
      </ModalFrame>

    </div>

  );
};

export default Opportunity;
